import React,{Component} from 'react'
import { Tabs ,Input,Button,message,Modal,Select,AutoComplete} from 'antd';
import Helmet from "react-helmet";
import './delivery.less'
import {getPublicOrderList} from '../../api'
const { TabPane } = Tabs;
const {Option} = Select;
export default class DeliveryQuery extends Component {
    state = {
        visible: false,
        searchValue:"",
        tabKey:'order',
        recordNoData:[],
        dataSource:[],
        recordNo:'',
        selectMap:{},
        allData:[],
        placeholder:'请输入13位订单号',
    }
    orderNoClick = () =>{
        const {recordNo,tabKey} = this.state
        if(tabKey && tabKey === 'order' && ( !recordNo || recordNo.length<13 )){
            message.error(this.state.placeholder)
            return
        }else if(tabKey && tabKey === 'boxNo' && ( !recordNo || recordNo.length<11 )){
            message.error(this.state.placeholder)
            return
        }else if(tabKey && tabKey === 'GPS' && ( !recordNo || recordNo.length<13 )){
            message.error(this.state.placeholder)
            return
        }
        if(!recordNo){
            message.error('请填写')
        }else{
            this.getOrderNoList(tabKey,recordNo)
        }
    }


    getOrderNoList = async (type,recordNo) => {
        let result = await getPublicOrderList(type,recordNo)
        if (result.code === 200) {
            let orderNo = ""
            let gpsNo = ""
            for(let item of result.data){
                if(type==='order' && item.orderNo == recordNo){
                    orderNo = item.orderNo
                    gpsNo = item.trailNo
                }else if(type==='GPS' && item.trailNo == recordNo){
                    orderNo = item.orderNo
                    gpsNo = item.trailNo
                }else if(type==='boxNo' && item.boxNo == recordNo){
                    orderNo = item.orderNo
                    gpsNo = item.trailNo
                }
            }
            if(orderNo!="" && orderNo!=undefined) {
                let path = '/trackQuery/'+orderNo
                if(gpsNo && gpsNo!=""){
                    path = path+"/"+gpsNo
                }
                this.props.history.push(path)
            }else{
                if(type==='order'){
                    message.error('订单号有误')
                }else if(type==='GPS'){
                    message.error('GPS设备号有误')
                }else{
                    message.error('集装箱号有误')
                }
            }

        }else {
            message.error(result.message)
        }

    }

    getOrderAutoList = async (type,recordNo) => {
        if(type && type === 'order' && ( !recordNo || recordNo.length<13 )){
            this.setState({
                dataSource:[]
            })
            return
        }else if(type && type === 'boxNo' && ( !recordNo || recordNo.length<11 )){
            this.setState({
                dataSource:[]
            })
            return
        }else if(type && type === 'GPS' && ( !recordNo || recordNo.length<13 )){
            this.setState({
                dataSource:[]
            })
            return
        }else if(!recordNo || recordNo.length<2){
            this.setState({
                dataSource:[]
            })
            return
        }
        let result = await getPublicOrderList(type,recordNo)
        if (result.code === 200) {
          if(result.data){
              this.setState({
                  allData:result.data
              })
              let newType = type
              if(type=="order"){
                  newType = "orderNo"
              }else if (type=="boxNo"){
                  newType = "boxNo"
              }else if (type == "GPS"){
                  newType = "trailNo"
              }
              let dataSource = []
              for(let i of result.data){
                  if(i[newType] !=undefined) {
                      dataSource.push(i[newType])
                  }
              }
              // this.setState({
              //     dataSource:[]
              // })
              const data = new Set(dataSource);
              this.setState({
                  dataSource:Array.from(data)
              })
          }
        }else {
            this.setState({
                dataSource:[]
            })
        }
    }

    tabChange = (key) =>{
        if(key==='order'){
            this.setState({
                placeholder:'请输入13位订单号'
            })
        }else if(key==='boxNo'){
            this.setState({
                placeholder:'请输入11位集装箱号'
            })
        }else if(key==='GPS'){
            this.setState({
                placeholder:'请输入13位GPS'
            })
        }
        this.setState({
            selectMap:Object.assign(this.state.selectMap,{[this.state.tabKey]:this.state.searchValue})
        });
        this.setState({
            searchValue:this.state.selectMap[key]
        });
        this.setState({
            tabKey:key
        })
    }

    onFocus = value => {
        const {tabKey} = this.state
        this.getOrderAutoList(tabKey,value)
    }
    onSelect = value => {
        let type = this.state.tabKey
        let orderNo = ''
        let gpsNo = ''
        if(type=="order"){
            type = "orderNo"
        }else if (type=="boxNo"){
            type = "boxNo"
        }else if (type == "GPS"){
            type = "trailNo"
        }
        for(let i of this.state.allData){
            if(i[type] == value){
                orderNo = i["orderNo"]
                gpsNo = i["trailNo"]
                break;
            }
        }
        let path = '/trackQuery/'+orderNo
        if(gpsNo && gpsNo!=""){
            path = path+"/"+gpsNo
        }
        this.props.history.push(path)
    }
    onChange = value => {
        this.setState({
            searchValue:value,
            recordNo:value
        });
        const {tabKey} = this.state
        this.getOrderAutoList(tabKey,value)
       //console.log(value)
    }
    render () {
        const {tabKey,dataSource,searchValue} = this.state
        const autoCompleteEnter =(control)=>{
            if(control){
                control.select.rcSelect.onInputKeyDown = (e) => {
                    if(e.keyCode == 13){
                        control.select.rcSelect.setOpenState(false,true);
                        this.orderNoClick()
                        return;
                    }
                }
            }
        }
        return (

            <div className='deleveryQuery'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                />
                <div className="logo"><a href="http://47.105.147.107"></a> </div>
                <div className="delivery-content">
                    <div className='delivery-content-title'>
                        <p>跨境货运物流轨迹查询</p>
                        <p className='en'>LOGISTICS TRACK QUERY</p>
                    </div>
                    <Tabs defaultActiveKey={tabKey} onChange={this.tabChange}>
                        <TabPane tab="订单号" key="order">
                        </TabPane>
                        <TabPane tab="集装箱号" key="boxNo">
                        </TabPane>
                        <TabPane tab="GPS设备号" key="GPS">
                        </TabPane>
                    </Tabs>
                    {
                        <div>
                            <AutoComplete
                                dataSource={dataSource}
                                style={{ width: '80%',height:'50px'}}
                                onFocus={this.onFocus}
                                onSearch ={this.onChange}
                                onSelect={this.onSelect}
                                value={searchValue}
                                defaultActiveFirstOption={false}
                                ref={autoCompleteEnter}
                                placeholder={this.state.placeholder}
                            />
                            <Button type='primary' onClick={this.orderNoClick}>查询</Button>
                        </div>
                    }
                </div>
                <div className='delivery-content-footer'>
                    赣ICP备20005970号-1
                </div>
            </div>
        )
    }
}